import type {HeadProps} from 'gatsby'
import {graphql, useStaticQuery} from 'gatsby'
import React from 'react'
import type {ReactNode} from 'react'

import type {SeoQuery} from '@/graphql-types'
import type {Meta} from '@helios/shared/components/seo-base'
import {SEOBase} from '@helios/shared/components/seo-base'
import {useLocalizedContent} from '@helios/shared/hooks/use-localized-content'
import locales from '@helios/shared/locale/locales'
import type {PageContext} from '@helios/shared/types/page-context'

type Props = Partial<Meta> & {
    preventIndexing?: boolean
    location: HeadProps['location']
    pageContext: PageContext
    canonicalLocation?: string
    children?: ReactNode
}

export const SEO = (props: Props) => {
    const {allPrismicSeo, site} = useStaticQuery<SeoQuery>(query)
    const [content] = useLocalizedContent(allPrismicSeo.nodes, {
        localeCode: props.pageContext.locale,
    })

    const fallback = {
        title: content?.data.title,
        description: content?.data.description,
        openGraphImageUrl: content?.data.defaultOpenGraphImage.url ?? '',
    }

    return (
        <SEOBase
            siteName={site?.siteMetadata.siteName}
            locales={locales}
            fallback={fallback}
            {...props}
        />
    )
}

const query = graphql`
    query SEO {
        site {
            siteMetadata {
                siteName
            }
        }
        allPrismicSeo {
            nodes {
                lang
                data {
                    title
                    description
                    defaultOpenGraphImage: default_open_graph_image {
                        url
                    }
                }
            }
        }
    }
`

export default SEO
